import React from 'react';
import { Box, useToken } from '@chakra-ui/react';
import {
  HStack,
  Text,
  VStack,
} from '@ayble-health/dashboard-components';
import { Check } from 'lucide-react';
import type { SuspectIdentificationBlockData } from '../../../models/suspectIdentificationBlockData';
import { formatDate } from '../utils';
import { getRequestedNextStepLabel } from './utils';

type Props = {
  nutritionBlockData: SuspectIdentificationBlockData;
};

export const SuspectIdentificationDetailsContent = ({
  nutritionBlockData,
}: Props) => {
  const requestedFoods = nutritionBlockData.desired_food_list || [];
  const nextStepLabel = getRequestedNextStepLabel(
    nutritionBlockData.connect_preference
  );
  const formattedEndedOn = formatDate(
    nutritionBlockData.ended_on ?? undefined,
    'MMM D'
  );
  const [secondary200] = useToken('colors', ['secondary.200']);

  return (
    <VStack>
      <Box
        bgColor={'feather.100'}
        borderColor={'cloud.200'}
        borderRadius={'xl'}
        borderWidth={1}
        overflow={'hidden'}
      >
        <HStack
          alignItems={'center'}
          borderBottomWidth={1}
          borderColor={'cloud.200'}
          justifyContent={'space-between'}
          px={4}
          py={3}
        >
          <Text color={'secondary.500'} fontSize={'md'} fontWeight={'medium'}>
            App Check-in
          </Text>
          <Text color={'secondary.200'} fontSize={'sm'} fontWeight={'medium'}>
            {formattedEndedOn}
          </Text>
        </HStack>

        <VStack px={4} py={4} gap={4}>
          <HStack alignItems={'flex-start'} gap={2}>
            <Check
              color={secondary200}
              size={12}
              style={{ marginTop: 4 }}
            />

            <Text
              color={'secondary.500'}
              flex={1}
              fontSize={'md'}
              fontWeight={'normal'}
            >
              Requested next steps:{' '}
              <Text color={'secondary.500'} fontSize={'md'} fontWeight={'bold'}>
                {nextStepLabel}
              </Text>
            </Text>
          </HStack>

          <HStack alignItems={'flex-start'} gap={2}>
            <Check
              color={secondary200}
              size={12}
              style={{ marginTop: 4 }}
            />

            <VStack flex={1} gap={0.5}>
              <Text
                color={'secondary.500'}
                fontSize={'md'}
                fontWeight={'normal'}
              >
                Requested suspect trigger list:
              </Text>

              {!!requestedFoods.length &&
                requestedFoods.map((food) => (
                  <Text
                    key={food.id}
                    color={'secondary.500'}
                    fontSize={'md'}
                    fontWeight={'bold'}
                    pl={2}
                  >
                    - {food.display_name}
                  </Text>
                ))}

              {!requestedFoods.length && (
                <Text
                  color={'blueGray.600'}
                  fontSize={'sm'}
                  fontWeight={'bold'}
                  pl={2}
                >
                  --
                </Text>
              )}
            </VStack>
          </HStack>

          <Text color={'secondary.500'} fontSize={'md'} fontWeight={'normal'}>
            {nutritionBlockData.open_feedback
              ? `"${nutritionBlockData.open_feedback}"`
              : '--'}
          </Text>
        </VStack>
      </Box>
    </VStack>
  );
};
